module.exports = __webpack_public_path__ + "img/plug10.b18db00c.jpg";